import { makeStyles } from '@material-ui/core';

import { Organization } from '../../types/organization.type';
import MembersTable from '../Tables/MembersTable.component';
import AddMembersDialog from '../Modals/AddMembersDialog.component';

type Props = {
  organization: Organization;
  refreshOrganization: () => Promise<void>;
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },

  header: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export default function OrganizationMembersTab({ organization, refreshOrganization }: Props) {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <div className={classes.header}>
        <AddMembersDialog
          actionLabel="Ajouter"
          organizationId={organization.id}
          refreshOrganization={refreshOrganization}
        />
      </div>
      <MembersTable
        maxHeight="74svh"
        members={organization.members}
        organizationId={organization.id}
        hasDeliveryPoints={(organization.deliveryPoints ?? []).length > 0}
        refreshOrganization={refreshOrganization}
      />
    </section>
  );
}
